//let ratingSnippetGlobalSettings;
function renderSnippet2(rating, num_ratings, text, linebreak, mode) {
    let ratingHtml = '';
    switch (mode) {
    case 'minimal':
        rating = Math.round(rating * 100) / 100;
        ratingHtml += '<i class="ruk-icon-percentage-star--100"></i>';
        ratingHtml += '<span class="ruk-rating-snippet-count">' + rating + '</span>';
        if (linebreak == true) {
            ratingHtml += '<br />';
        } else {
            ratingHtml += '<span style="display: inline-block; min-width: 8px"></span>';
        }
        if (text) {
            ratingHtml += '<span class="ruk-rating-snippet-count">aus' + num_ratings + text + '</span>';
        }
        break;
    case 'extended':
    default:
        roundedRating = Math.round(rating * 4) / 4;
        for (let i = 1; i <= 5; i++) {
            if (roundedRating >= i) {
                ratingHtml += '<i class="ruk-icon-percentage-star--100"></i>';
            } else if (roundedRating >= i - 0.25) {
                ratingHtml += '<i class="ruk-icon-percentage-star--75"></i>';
            } else if (roundedRating >= i - 0.5) {
                ratingHtml += '<i class="ruk-icon-percentage-star--50"></i>';
            } else if (roundedRating >= i - 0.75) {
                ratingHtml += '<i class="ruk-icon-percentage-star--25"></i>';
            } else {
                ratingHtml += '<i class="ruk-icon-percentage-star--0"></i>';
            }
        }
        if (linebreak == true) {
            ratingHtml += '<br />';
        }
        if (mode == 'extended') {
            ratingHtml += '<span style="margin-left: 5px" class="ruk-rating-snippet-count"><b>' + (Math.round(rating * 100) / 100) + '</b>/5.00 </span>';
        }
        ratingHtml += '<span class="ruk-rating-snippet-count">aus ' + '<b>' + num_ratings + '</b>' + text + '</span>';
        
        break;
    }
    return ratingHtml;
}
reinitialiseRatingSnippet2 = function() {
    if (ratingSnippetGlobalSettings) {
        ratingSnippet2(ratingSnippetGlobalSettings.class, ratingSnippetGlobalSettings.options);
    }
}
ratingSnippet2 = function(ratingClassName, opts) {
    ratingSnippetGlobalSettings = {
        'class': ratingClassName,
        'options': opts
    };
    rsCssId = 'rating-snippet-stars__css';
    rsCssTag = document.getElementById(rsCssId);
    if (!rsCssTag) {
        rsCssTag = document.createElement('link');
        rsCssTag.rel = 'stylesheet';
        rsCssTag.type = 'text/css';
        rsCssTag.id = rsCssId;
        rsCssTag.href = 'https://cdn.icomoon.io/40686/revsglobal-pr-mod/style-cf.css?ezld0b';
        document.getElementsByTagName('HEAD')[0].appendChild(rsCssTag);
    }
    if (opts == undefined) {
        opts = {}
    }
    if (opts.usePolaris) {
        polarisId = 'rating-snippet-polaris__script';
        polarisTag = document.getElementById(polarisId);
        if (!polarisTag) {
            polarisScript = document.createElement('script');
            polarisScript.type = 'text/javascript';
            polarisScript.id = polarisId;
            polarisScript.async = true;
            polarisScript.src = 'https://widget.reviews.io/polaris/build.js';
            document.getElementsByTagName('head')[0].appendChild(polarisScript);
        }
    }
    if (opts.linebreak == undefined) {
        opts.linebreak = false;
    }
    if (opts.mode == undefined) {
        opts.mode = false;
    }
    if (opts.color == undefined) {
        opts.color = '#67c116'
    }
    if (opts.useCustomLookup == undefined) {
        opts.useCustomLookup = false;
    }
    if (opts.useProductGroup == undefined) {
        opts.useProductGroup = false;
    }
    if (opts.mpnLookup == undefined) {
        opts.mpnLookup = false;
    }
    if (opts.customLookupSkuFallback == undefined) {
        opts.customLookupSkuFallback = false;
    }
    if (opts.showNumberDatesFormat == undefined) {
        opts.showNumberDatesFormat = 'dd.MM.yyyy';
    }
    if (opts.minRating == undefined) {
        opts.minRating = 1;
    }
    if (opts.showNumberDates == undefined) {
        opts.showNumberDates = false;
    }
    if (opts.enableSyndication == undefined) {
        opts.enableSyndication = false;
    }
    if (opts.translateAverage == undefined) {
        opts.translateAverage = 'Average';
    }
    if (opts.translateReviews == undefined) {
        opts.translateReviews = 'Reviews';
    }
    if (opts.translateNoReviews == undefined) {
        opts.translateNoReviews = 'Be the first to review this product.';
    }
    if (opts.translateMoreRatings == undefined) {
        opts.translateMoreRatings = 'More Ratings';
    }
    if (opts.translateNoComments == undefined) {
        opts.translateNoComments = 'This review has no comments';
    }
    if (opts.translateReplyFrom == undefined) {
        opts.translateReplyFrom = 'Reply From';
    }
    if (opts.translatePosted == undefined) {
        opts.translatePosted = 'Posted';
    }
    if (opts.translateWriteReview == undefined) {
        opts.translateWriteReview = 'Write a Review';
    }
    if (opts.translateShow == undefined) {
        opts.translateShow = 'Show';
    }
    if (opts.translateDetails == undefined) {
        opts.translateDetails = 'More';
    }
    if (opts.translateRateThisProduct == undefined) {
        opts.translateRateThisProduct = 'Rate This Product';
    }
    if (opts.translateSelectProduct == undefined) {
        opts.translateSelectProduct = 'Select Product:';
    }
    if (opts.translateWriteReviewPlaceholder == undefined) {
        opts.translateWriteReviewPlaceholder = 'Write your review here';
    }
    if (opts.translateSubmitReview == undefined) {
        opts.translateSubmitReview = 'Submit Review';
    }
    if (opts.translateYourNamePlaceholder == undefined) {
        opts.translateYourNamePlaceholder = 'Your Name';
    }
    if (opts.translateEmailAddressPlaceholder == undefined) {
        opts.translateEmailAddressPlaceholder = 'Email Address';
    }
    if (opts.translateThankyouForYourReview == undefined) {
        opts.translateThankyouForYourReview = '<strong>Thank you</strong> for your review!';
    }
    if (opts.translateYourReviewHasBeenSubmitted == undefined) {
        opts.translateYourReviewHasBeenSubmitted = 'Your review has been submitted.';
    }
    if (opts.translateReviewsCount == undefined) {
        opts.translateReviewsCount = 'Reviews';
    }
    if (opts.translateVerifiedBuyer == undefined) {
        opts.translateVerifiedBuyer = 'Verified Buyer';
    }
    if (opts.translateUnverifiedBuyer == undefined) {
        opts.translateUnverifiedBuyer = 'Unverified Buyer';
    }
    if (opts.translateVerifiedBuyerYes == undefined) {
        opts.translateVerifiedBuyerYes = 'Yes';
    }
    if (opts.translateVerifiedBuyerNo == undefined) {
        opts.translateVerifiedBuyerNo = 'No';
    }
    if (opts.translateAnonymousReviewerName == undefined) {
        opts.translateAnonymousReviewerName = 'Anonymous';
    }
    if (opts.enableProductName == undefined) {
        opts.enableProductName = false;
    }
    if (opts.formatReviewCount == undefined) {
        opts.formatReviewCount = false;
    }
    if (opts.formatLanguage == undefined) {
        opts.formatLanguage = 'en-GB';
    }
    if (opts.lang == undefined) {
        opts.lang = 'en';
    }
    if (opts.snippetPopup == undefined) {
        opts.snippetPopup = true;
    }
    if (opts.dataAttributeSelector == undefined) {
        opts.dataAttributeSelector = 'data-sku';
    }
    let store;
    let sku = [];
    var rating_snippets2 = document.querySelectorAll('.' + ratingClassName);
    if (rating_snippets2.length > 0) {
        for (let i = 0; i < rating_snippets2.length; i++) {
            let snippet = rating_snippets2[i];
            let _sku = snippet.getAttribute(opts.dataAttributeSelector).split(';');
            sku = sku.concat(_sku); 
        }
    }
    let xmlhttp;
    if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
    } else {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            let data = JSON.parse(xmlhttp.responseText);
            let rating_snippets2 = document.querySelectorAll('.' + ratingClassName);
            if (rating_snippets2.length > 0) {
                for (let x = 0; x < rating_snippets2.length; x++) {
                    let snippet = rating_snippets2.item(x);
                    let _sku = snippet.getAttribute(opts.dataAttributeSelector).split(';');
                    let rating = 0
                      , rating_count = 0
                      , num_ratings = 0;
                    let addedSkus = [];
                    for (i in data) {
                        for (let s in _sku) {
                            if (_sku[s] != '' && _sku[s] != undefined && data[i] != undefined && data[i].sku != undefined && (_sku[s].toString().trim().toLowerCase() == data[i].sku.toString().trim().toLowerCase() || data[i].lookup && data[i].lookup.split(';').indexOf(_sku[s]) >= 0) && addedSkus.indexOf(data[i].sku) == -1) {
                                rating += parseFloat(data[i].average_rating) * data[i].num_ratings;
                                num_ratings += parseFloat(data[i].num_ratings);
                                rating_count++;
                                addedSkus.push(data[i].sku);
                            }
                        }
                    }
                    rating = rating / num_ratings;
                    let ratingText = (opts.text != undefined) ? ' ' + opts.text : '';
                    if (ratingText == ' Reviews' && num_ratings == 1) {
                        ratingText = ' Review';
                    }
                    if (rating_count > 0) {
                        if (opts.formatReviewCount) {
                            num_ratings = num_ratings.toLocaleString(opts.formatLanguage);
                        }
                        snippet.innerHTML = renderSnippet2(rating, num_ratings, ratingText, opts.linebreak, opts.mode);
                        snippet.setAttribute('data-done', true);
                        if (window.__fullPictureEvents) {
                            snippet.setAttribute('data-rating', rating);
                            snippet.setAttribute('data-count', num_ratings);
                            snippet.setAttribute('data-product-name', data[i].name);
                        }
                    } else if (opts.showEmptyStars) {
                        snippet.innerHTML = renderSnippet2(0, 0, ratingText, opts.linebreak, opts.mode);
                        snippet.setAttribute('data-done', true);
                    }
                    if (opts.callback) {
                        opts.callback({
                            data: data,
                            rating: rating,
                            count: rating_count
                        });
                    }
                }
            }
        }
    }
    let _sku = encodeURIComponent(sku.join(';'));
    if (_sku == '') {
        return;
    }
    let queryString = 'sku=' + _sku + '&store=' + opts.store + '&useCustomLookup=' + opts.useCustomLookup + '&customLookupSkuFallback=' + opts.customLookupSkuFallback + '&useProductGroup=' + opts.useProductGroup + '&mpnLookup=' + opts.mpnLookup + '&minRating=' + opts.minRating;
    if (opts.tag) {
        queryString += '&tag=' + opts.tag;
    }
    if (opts.lang) {
        queryString += '&lang=' + opts.lang;
    }
    if (opts.enableSyndication) {
        queryString += '&enableSyndication=' + opts.enableSyndication;
    }
    if (queryString.length > 2000) {
        xmlhttp.open('POST', 'https://api.reviews.io/product/rating-batch', true);
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xmlhttp.send(queryString);
    } else {
        xmlhttp.open('GET', 'https://api.reviews.io/product/rating-batch?' + queryString, true);
        xmlhttp.send();
    }
    let modal = document.createElement('div');
    modal.innerHTML = '<div id="reviews_fade" style="display:none;z-index:4000"><div id="reviews_container"><div id="reviews_container-close" class="close">&times;</div><div id="reviews_widget" style="position:relative;z-index:4000;-webkit-overflow-scrolling:touch"></div> </div></div>';
    document.body.appendChild(modal);
    var rating_snippets2 = document.querySelectorAll('.' + ratingClassName);
    if (rating_snippets2.length > 0) {
        for (let i in rating_snippets2) {
            let snippet = rating_snippets2.item(i);
            if (opts.color != undefined) {
                snippet.style.color = opts.color;
            }
            if ((typeof productWidget != 'undefined' || opts.usePolaris) && snippet.onclick == null && opts.snippetPopup) {
                snippet.onclick = function(event) {
                    let sku = this.getAttribute(opts.dataAttributeSelector);
                    if (!this.getAttribute('data-done')) {
                        return;
                    }
                    let root = document.getElementsByTagName('html')[0];
                    document.getElementById('reviews_widget').innerHTML = '';
                    if (opts.usePolaris && typeof ReviewsWidget != "undefined") {
                        let options = {
                            store: opts.store,
                            widget: 'polaris',
                            options: {
                                types: 'product_review',
                                lang: opts.hasOwnProperty("lang") ? opts.lang : 'en',
                                layout: '',
                                enable_syndication: opts.enableSyndication,
                                per_page: 8,
                                product_review: {
                                    sku: sku,
                                    hide_if_no_results: false,
                                    min_rating: opts.minRating ? opts.minRating : 1,
                                },
                                header: {
                                    enable_summary: true,
                                    enable_ratings: true,
                                    enable_attributes: true,
                                    enable_image_gallery: true,
                                    enable_percent_recommended: false,
                                    enable_write_review: (opts.writeButton != undefined ? opts.writeButton : true),
                                    enable_ask_question: true,
                                    enable_sub_header: true,
                                    always_show: true,
                                },
                                filtering: {
                                    enable: true,
                                    enable_text_search: true,
                                    enable_sorting: true,
                                    enable_overall_rating_filter: true,
                                    enable_ratings_filters: true,
                                    enable_attributes_filters: true,
                                },
                                reviews: {
                                    enable_replies: opts.showPopupReplies,
                                    enable_avatar: true,
                                    enable_reviewer_name: true,
                                    enable_reviewer_address: true,
                                    reviewer_address_format: 'city, country',
                                    enable_verified_badge: true,
                                    enable_reviewer_recommends: true,
                                    enable_attributes: true,
                                    enable_product_name: true,
                                    enable_images: true,
                                    enable_ratings: true,
                                    enable_share: true,
                                    enable_helpful_vote: true,
                                    enable_helpful_display: true,
                                    enable_report: true,
                                    enable_date: true,
                                },
                            },
                            styles: {
                                '--base-font-size': '16px',
                                '--common-button-font-family': 'inherit',
                                '--common-button-font-size': '16px',
                                '--common-button-font-weight': '500',
                                '--common-button-letter-spacing': '0',
                                '--common-button-text-transform': 'none',
                                '--common-button-vertical-padding': '10px',
                                '--common-button-horizontal-padding': '20px',
                                '--common-button-border-width': '2px',
                                '--common-button-border-radius': '0px',
                                '--primary-button-bg-color': '#0E1311',
                                '--primary-button-border-color': '#0E1311',
                                '--primary-button-text-color': '#ffffff',
                                '--secondary-button-bg-color': 'transparent',
                                '--secondary-button-border-color': '#0E1311',
                                '--secondary-button-text-color': '#0E1311',
                                '--common-star-color': opts.color,
                                '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
                                '--medium-star-size': '22px',
                                '--small-star-size': '19px',
                                '--heading-text-color': '#0E1311',
                                '--heading-text-font-weight': '600',
                                '--heading-text-font-family': 'inherit',
                                '--heading-text-line-height': '1.4',
                                '--heading-text-letter-spacing': '0',
                                '--heading-text-transform': 'none',
                                '--body-text-color': '#0E1311',
                                '--body-text-font-weight': '400',
                                '--body-text-font-family': 'inherit',
                                '--body-text-line-height': '1.4',
                                '--body-text-letter-spacing': '0',
                                '--body-text-transform': 'none',
                                '--inputfield-text-font-family': 'inherit',
                                '--input-text-font-size': '14px',
                                '--inputfield-text-font-weight': '400',
                                '--inputfield-text-color': '#0E1311',
                                '--inputfield-border-color': 'rgba(0,0,0,0.2)',
                                '--inputfield-background-color': 'transparent',
                                '--inputfield-border-width': '1px',
                                '--inputfield-border-radius': '0px',
                                '--common-border-color': 'rgba(0,0,0,0.15)',
                                '--common-border-width': '1px',
                                '--common-sidebar-width': '190px',
                                '--slider-indicator-bg-color': 'rgba(0,0,0,0.1)',
                                '--slider-indicator-button-color': '#0E1311',
                                '--slider-indicator-width': '190px',
                                '--badge-icon-color': '#0E1311',
                                '--badge-icon-font-size': 'inherit',
                                '--badge-text-color': '#0E1311',
                                '--badge-text-font-size': 'inherit',
                                '--badge-text-letter-spacing': 'inherit',
                                '--badge-text-transform': 'inherit',
                                '--author-font-size': 'inherit',
                                '--author-text-transform': 'none',
                                '--avatar-thumbnail-size': '60px',
                                '--avatar-thumbnail-border-radius': '100px',
                                '--avatar-thumbnail-text-color': '#0E1311',
                                '--avatar-thumbnail-bg-color': 'rgba(0,0,0,0.1)',
                                '--photo-video-thumbnail-size': '80px',
                                '--photo-video-thumbnail-border-radius': '0px',
                                '--mediaslider-scroll-button-icon-color': '#0E1311',
                                '--mediaslider-scroll-button-bg-color': 'rgba(255, 255, 255, 0.85)',
                                '--mediaslider-overlay-text-color': '#ffffff',
                                '--mediaslider-overlay-bg-color': 'rgba(0, 0, 0, 0.8))',
                                '--mediaslider-item-size': '110px',
                                '--pagination-tab-text-color': '#0E1311',
                                '--pagination-tab-text-transform': 'none',
                                '--pagination-tab-text-letter-spacing': '0',
                                '--pagination-tab-text-font-size': '16px',
                                '--pagination-tab-text-font-weight': '600',
                                '--pagination-tab-active-text-color': '#0E1311',
                                '--pagination-tab-active-text-font-weight': '600',
                                '--pagination-tab-active-border-color': '#0E1311',
                                '--pagination-tab-border-width': '3px',
                            },
                        };
                        if (opts.useMpn)
                            options.options.product_review.mpn = sku;
                        if (opts.useCustomLookup)
                            options.options.product_review.lookup = sku;
                        if (opts.tag)
                            options.options.product_review.tag = opts.tag;
                        if (typeof ReviewsWidgetInstances != "undefined" && ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]] && typeof ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state == "object" && typeof ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config == "object" && typeof ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config.widget == "string" && ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config.widget == "polaris" && typeof ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config.styles == "object") {
                            options.styles = ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config.styles;
                        }
                        new ReviewsWidget('#reviews_widget',options);
                    } else {
                        let options = {
                            store: opts.store,
                            sku: sku,
                            css: opts.css,
                            primaryClr: opts.color,
                            neutralClr: "#EBEBEB",
                            buttonClr: "#EEE",
                            textClr: "#333",
                            tabClr: "#eee",
                            questions: true,
                            showTabs: false,
                            ratingStars: false,
                            showAvatars: true,
                            snippetPopup: opts.snippetPopup ? opts.snippetPopup : true,
                            minRating: opts.minRating ? opts.minRating : 1,
                            hidePoweredBy: opts.hidePoweredBy ? opts.hidePoweredBy : false,
                            hideLogo: opts.hideLogo ? opts.hideLogo : false,
                            showNumberDates: opts.showNumberDates,
                            showNumberDatesFormat: opts.showNumberDatesFormat,
                            enableProductName: opts.enableProductName,
                            translateAverage: opts.translateAverage,
                            translateReviews: opts.translateReviews,
                            translateNoReviews: opts.translateNoReviews,
                            translateMoreRatings: opts.translateMoreRatings,
                            translateNoComments: opts.translateNoComments,
                            translateReplyFrom: opts.translateReplyFrom,
                            translatePosted: opts.translatePosted,
                            translateWriteReview: opts.translateWriteReview,
                            translateShow: opts.translateShow,
                            translateDetails: opts.translateDetails,
                            translateRateThisProduct: opts.translateRateThisProduct,
                            translateSelectProduct: opts.translateSelectProduct,
                            translateWriteReviewPlaceholder: opts.translateWriteReviewPlaceholder,
                            translateSubmitReview: opts.translateSubmitReview,
                            translateYourNamePlaceholder: opts.translateYourNamePlaceholder,
                            translateEmailAddressPlaceholder: opts.translateEmailAddressPlaceholder,
                            translateThankyouForYourReview: opts.translateThankyouForYourReview,
                            translateYourReviewHasBeenSubmitted: opts.translateYourReviewHasBeenSubmitted,
                            translateReviewsCount: opts.translateReviewsCount,
                            translateVerifiedBuyer: opts.translateVerifiedBuyer,
                            translateUnverifiedBuyer: opts.translateUnverifiedBuyer,
                            translateVerifiedBuyerYes: opts.translateVerifiedBuyerYes,
                            translateVerifiedBuyerNo: opts.translateVerifiedBuyerNo,
                            translateAnonymousReviewerName: opts.translateAnonymousReviewerName,
                            formatReviewCount: opts.formatReviewCount ? opts.formatReviewCount : false,
                            formatLanguage: opts.hasOwnProperty("formatLanguage") ? opts.formatLanguage : 'en-GB',
                            lang: opts.hasOwnProperty("lang") ? opts.lang : 'en',
                        };
                        if (opts.useMpn) {
                            options.mpn = sku;
                        }
                        if (opts.useCustomLookup) {
                            options.lookup = sku;
                        }
                        if (opts.useProductGroup) {
                            options.productGroup = sku;
                        }
                        if (opts.tag) {
                            options.tag = opts.tag;
                        }
                        if (opts.writeButton != undefined) {
                            options.writeButton = opts.writeButton;
                        }
                        productWidget("reviews_widget", options);
                    }
                    document.getElementById('reviews_fade').style.display = 'block';
                    document.body.classList.add("reviews-popup");
                    root.classList.add('reviews-popup');
                }
            }
        }
    }
    document.getElementById('reviews_container-close').onclick = function() {
        let root = document.getElementsByTagName('html')[0];
        document.getElementById('reviews_fade').style.display = 'none';
        document.body.classList.remove("reviews-popup");
        root.classList.remove('reviews-popup');
    }
}
;
if (typeof ratingSnippetCallback == 'function') {
    ratingSnippetCallback();
}
